<template>
  <div class="container">
    <div>
      <div class="background-color-table">
        <h4>Cuadro 3</h4>
        <h4 class="subtitulo-c3">
          Indicadores de Gestión Financiera
        </h4>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col"></th>
            <th scope="col"></th>
            <th scope="col"></th>
            <th scope="col">Efectivo</th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
        </thead>
        <thead>
          <tr>
            <th scope="col">Nombre Indicador</th>
            <th scope="col">Fórmula Indicador</th>
            <th scope="col">Unidad de medida</th>
            <th scope="col">{{ anio - 2 }}</th>
            <th scope="col">{{ anio - 1 }}</th>
            <th scope="col">{{ anio }}</th>
            <th scope="col">Notas</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td scope="col">
              {{ tablaOne.indicadorRelacion }}
            </td>
            <td scope="col">
              {{ tablaOne.formulaRelacion }}
            </td>
            <td scope="col">
              %
            </td>
            <td scope="col">
              <b-form-input :disabled="readOnly"
                v-model="tablaOne.anioTwoRelacion"
                type="text"
              ></b-form-input>
            </td>
            <td scope="col">
              <b-form-input :disabled="readOnly"
                v-model="tablaOne.anioOneRelacion"
                type="text"
              ></b-form-input>
            </td>
            <td scope="col">
              <b-form-input :disabled="readOnly"
                v-model="tablaOne.AnioActualRelacion"
                type="text"
              ></b-form-input>
            </td>
            <td scope="col">
              <b-form-input :disabled="readOnly"
                v-model="tablaOne.NotasRelacion"
                type="text"
              ></b-form-input>
            </td>
          </tr>
          <tr>
            <td scope="col">
              {{ tablaOne.indicadorPorentaje }}
            </td>
            <td scope="col">
              {{ tablaOne.formulaPorcentaje }}
            </td>
            <td scope="col">
              %
            </td>
            <td scope="col">
              <b-form-input :disabled="readOnly"
                v-model="tablaOne.anioTwoPorcentaje"
                type="text"
              ></b-form-input>
            </td>
            <td scope="col">
              <b-form-input :disabled="readOnly"
                v-model="tablaOne.anioOnePorcentaje"
                type="text"
              ></b-form-input>
            </td>
            <td scope="col">
              <b-form-input :disabled="readOnly"
                v-model="tablaOne.anioActualPorcentaje"
                type="text"
              ></b-form-input>
            </td>
            <td scope="col">
              <b-form-input :disabled="readOnly"
                v-model="tablaOne.notasPorcentaje"
                type="text"
              ></b-form-input>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["tablaOne", "readOnly"],
  data() {
    return {
      anio: process.env.VUE_APP_ANIO,
    };
  },
};
</script>

<style scoped>
.subtitulo-c3 {
  font-size: 0.95rem;
  font-weight: bold;
  margin: 0;
}
.total {
  display: flex;
  justify-content: space-evenly;
}

.background-color-table {
  background-color: #f5f5f5;
  margin: 0;
}

h4 {
  font-size: 1.1rem;
  color: #2b425f;
  font-weight: bold;
  margin: 0;
  text-align: center;
}
hr {
  margin: 0;
  margin-top: 10px;
  margin-bottom: 10px;
}

.table > tbody,
.table > thead {
  vertical-align: middle;
}
.button-add {
  background: #25a2b7 !important;
  color: white !important;
  border: none;
  width: 25px;
  height: 25px;
  border-radius: 14px;
  padding: 0 !important;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 0;
}

.table-title {
  background: #efefef;
}

input {
  width: 90%;
  border: 1px solid #ccc;
  background: transparent !important;
}

table {
  font-size: 1rem !important;
  margin: 0;
  border: 1px solid #f5f5f5;
}
thead {
  background-color: #f5f5f5;
  color: #24c6ab;
  text-align: left !important;
}
tr:hover {
  background: none !important;
  text-align: left !important;
}
th {
  font-size: 1rem !important;
  text-align: left !important;
}
.table-resaltar {
  font-weight: bold;
  background: #f5f5f5;
}
.table-resaltar:hover {
  background: #f5f5f5 !important;
}
td {
  text-align: left !important;
}

.table-striped > tbody > tr:nth-child(even) > td,
.table-striped > tbody > tr:nth-child(even) > th {
  background-color: #f5f5f5;
}
.table-striped > thead > tr > th {
  background-color: #f5f5f5;
}
</style>
